// extracted by mini-css-extract-plugin
export var actionButton = "_ll-t";
export var buttonContainer = "_ll-0";
export var buttonContainer2 = "_ll-1";
export var buttonSection = "_ll-2";
export var details = "_ll-3";
export var dropdownItem = "_ll-5";
export var dropdownItemsContainer = "_ll-4";
export var fileInput = "_ll-r";
export var headerButton = "_ll-6";
export var icon = "_ll-7";
export var input = "_ll-8";
export var macroListItem = "_ll-9";
export var mainContent = "_ll-a";
export var microText = "_ll-b";
export var modal = "_ll-w";
export var optionsButton = "_ll-c";
export var paperclip = "_ll-s";
export var pillContent = "_ll-d";
export var preview = "_ll-e";
export var preview2 = "_ll-f";
export var quillEditor = "_ll-q";
export var selectedMacro = "_ll-g";
export var sidebar = "_ll-h";
export var sidebarHeader = "_ll-j";
export var sidebarList = "_ll-i";
export var sidebarListItem = "_ll-k";
export var sidebarSearch = "_ll-l";
export var snoozeDurationWrapper = "_ll-v";
export var statusPillContainer = "_ll-m";
export var tagsContainer = "_ll-n";
export var unselectedMacro = "_ll-o";
export var variable = "_ll-u";
export var wrapper = "_ll-p";